module.exports = __webpack_public_path__ + "img/ompany_radio_button.18979fcc.svg";